/**
 * Where Settings → Custom Fields keeps the data requests that ask students
 * to fill in their fields. They used to have their own sidebar item; its old
 * path redirects here.
 */
export const DATA_REQUESTS_LOCATION = {
  name: 'admin-settings',
  query: { tab: 'custom_fields', entity: 'students', view: 'requests' },
} as const;
